import { Province, SoilType, SoilTypes } from '../models';

export const isNutrientsPollutedArea = (
  soilTypeId: number,
  soilTypes: SoilType[],
  province?: Province,
): boolean => {
  const soilType = soilTypes?.find((s) => s.id === soilTypeId);
  if (!soilType || !province) {
    return false;
  }

  return (
    nutrientsPollutedSoils.includes(soilType.name) && nutrientsPollutedProvinces.includes(province)
  );
};

export const isGroundWaterPreservationWithNitrogenCuts = (
  soilTypeId: number,
  soilTypes: SoilType[],
  isGroundWaterPreservation: boolean,
  province?: Province,
) => {
  const soilType = soilTypes?.find((s) => s.id === soilTypeId);
  if (!soilType || !province) {
    return false;
  }

  return (
    isGroundWaterPreservation &&
    nutrientsPollutedSoils.includes(soilType.name) &&
    nutrientsPollutedProvinces.includes(province)
  );
};

const nutrientsPollutedProvinces = [
  Province.Overijssel,
  Province.Gelderland,
  Province.Utrecht,
  Province.NoordBrabant,
  Province.Limburg,
  'NoordBrabant',
];

const nutrientsPollutedSoils = [SoilTypes.Loss.toString(), SoilTypes.Zand.toString()];
